<mat-dialog-content>
  <div id="spinner" class="nd-apploader__spinner"></div>
  <div id="message" class="nd-apploader__text">{{ data.message }}</div>
</mat-dialog-content>
